module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ttuQjw/tc-custom/9781780102214.jpg?1702083668461",
      "alt": "This image is the cover for the book Guilt Trip, The Lina Townend Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Guilt Trip, The Lina Townend Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this charming British mystery, antiques dealer Lina Townend must contend with a prankster that takes things dangerously too far.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Things in Lina Townend’s life could be better. Her love life is in a holding pattern and her business is faltering now that a new antiques center with very reduced prices—and less attention to detail—has opened up nearby."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Lina doesn’t quite know what to do about her own problems, but when a local theater director asks her business partner Griff to star in her latest production, she encourages him to do it. At least one of them will get their minds off their troubles."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But things quickly turn sour at the theater when a series of pranks played on the “Curtain Call” cast turn nasty. Now, Lina is determined to figure out what’s really going on—before someone ends up breaking way more than a leg . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Judith Cutler\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Prize-winning short-story writer JUDITH CUTLER is the author of two acclaimed series of crime novels set in Birmingham. The Dying series features amateur sleuth Sophie Rivers, while in her police procedural series Inspector Kate Power lives up to her name. One-time Secretary of the Crime Writers' Association, Judith has taught Creative Writing at Birmingham University, and has run occasional writing courses elsewhere. Now a full-time writer, she lives near Canterbury with husband and crime-writer Edward Marston.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    SEVERN House\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0